export const getNum = (value) => {
  value = +value || 0;

  return value;
};

export const setNumberFixed = (value, fixed = 2) => {
  return (
    Number(
      Number(value).toLocaleString('en', {
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: fixed,
      })
    ) || 0
  );
};
